import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={4} width={32} height={24} rx={4} fill={props.fill || "white"} />
    <rect
      x={0.5}
      y={4.5}
      width={31}
      height={23}
      rx={3.5}
      stroke={props.stroke || "#161C24"}
      strokeOpacity={0.1}
    />
    <path
      d="M20 22C23.3137 22 26 19.3137 26 16C26 12.6863 23.3137 10 20 10C16.6863 10 14 12.6863 14 16C14 19.3137 16.6863 22 20 22Z"
      fill="#FFA200"
    />
    <path
      d="M12 22C15.3137 22 18 19.3137 18 16C18 12.6863 15.3137 10 12 10C8.68629 10 6 12.6863 6 16C6 19.3137 8.68629 22 12 22Z"
      fill="#EA001B"
    />
    <path
      d="M20 22C23.3137 22 26 19.3137 26 16C26 12.6863 23.3137 10 20 10C16.6863 10 14 12.6863 14 16C14 19.3137 16.6863 22 20 22Z"
      fill="#FFA200"
      fillOpacity={0.8}
    />
  </svg>
);
export default SVGComponent;
